
import { useContext } from 'react';
import { FiltersIcon } from '../../../../assets/icons/icons';
import Filters from '../Filters/Filters';
import './FiltersPopup.css';
import { FiltersContext } from '../../../../assets/contexts/filtersContext';
import MobilePopup from '../../../MobilePopup/MobilePopup';
import MiniPreloader from '../../../MiniPreloader/MiniPreloader';

function FiltersPopup({ isOpen, handleClose, popupName, isApplyActive }) {
    const { handleFiltersApply, handleFiltersReset, isLoading } = useContext(FiltersContext)
    return (
        <MobilePopup
            isOpen={isOpen}
            handleClose={handleClose}
            popupName={popupName}
            className={'filter-popup__popup'}
        >
            <div className='filter-popup'>
                <div>
                    <div className="filter-popup__heading">
                        <div></div>
                        <p className='filter-popup__title'>Фильтры</p>
                        <div onClick={() => {
                            handleClose({ name: popupName })
                        }}>
                            <svg className='filter-popup__icon' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M20 3.99998L4.0001 19.9999" stroke="black" stroke-width="2" stroke-linecap="round" />
                                <path d="M20 20L4.0001 4.00008" stroke="black" stroke-width="2" stroke-linecap="round" />
                            </svg>
                        </div>
                    </div>
                    <div className='filter-popup__list'>
                        <Filters />
                    </div>
                </div>

                <div className={`filter-popup__btns ${isApplyActive ? 'filter-popup__btns_with-apply' : ''} ${isLoading ? 'filter-popup__btns_loading' : ''}`}>
                    <button className='filter-popup__btn filter-popup__btn_reset' type='button' onClick={handleFiltersReset}>
                        Сбросить фильтры
                    </button>
                    {isApplyActive ?
                        <button className='filter-popup__btn filter-popup__btn_apply' type='button' onClick={() => {
                            handleFiltersApply()
                            handleClose({ name: popupName })
                        }}>
                            {isLoading ?
                                <MiniPreloader isLinkColor={true} />
                                :
                                'Применить'
                            }
                        </button> : null}
                </div>
            </div>
        </MobilePopup>
    );
}

export default FiltersPopup